import React, { useState, useEffect } from "react";
import Header from "../Header";
import Footer from "../Footer/Footer";
import "../Availability/availability.css";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
import api from "../../../config/axiosConfig";

function Availability() {
  const [events, setEvents] = useState([]);
  const localizer = momentLocalizer(moment);
  const [residenceColors, setResidenceColors] = useState({});

  useEffect(() => {
    const getAvailability = async () => {
      try {
        // Fetch bookings and residences
        const { data: bookings } = await api.get("/residential/bookings");
        const { data: residences } = await api.get("/residential");

        const colors = ["#ac92ed", "#6b9bf1", "#50c2e9", "#48cfad", "#ade747", "#ffce56"];
        let residenceColorMap = {};
        
        residences.forEach((res, index) => {
          residenceColorMap[res.id] = {
            name: res.name, // ✅ Store the residence name
            color: colors[index % colors.length], // ✅ Assign a unique color
          };
        });

        setResidenceColors(residenceColorMap);
        console.log("Residence Colors Map:", Object.entries(residenceColors));
        console.log("Bookings Data:", bookings); // Debugging log
        console.log("Residences Data:", residences); // Debugging log
  
        // Create events from actual booking data
        let formattedEvents = bookings.map((booking) => {
          let residence = residences.find((res) => res.id === booking.residenceId);
          let backgroundColor = residence ? residenceColorMap[residence.id]?.color : "#CCCCCC";
        
          return {
            title: "", // Keep title empty to show only dots
            start: new Date(booking.date),
            end: new Date(booking.date),
            backgroundColor: backgroundColor, // ✅ Now correctly using the color from the legend
          };
        });
  
        setEvents(formattedEvents);
        console.log("Formatted Events:", formattedEvents);
      } catch (error) {
        console.error("Error fetching availability:", error);
      }
    };
  
    getAvailability();
  }, []);
  
  return (
    <>
      <Header />
      <section className="availability">
        <div className="container py-5">
          <h2 className="text-white">Availability</h2>
          <div style={{ display: "flex", flexWrap: "wrap", marginBottom: "10px" }}>
        { Object.entries(residenceColors).map(([id, {color, name}]) => (
          <div key={id} style={{ display: "flex", alignItems: "center", marginRight: "15px" }}>
            <span
              style={{
                display: "inline-block",
                width: "15px",
                height: "15px",
                backgroundColor: color,
                marginRight: "5px",
                borderRadius: "3px",
               
              }}
            ></span>
            <span className="text-white">{name}</span>
          </div>
        ))}
      </div>
      <Calendar
          localizer={localizer}
          events={events}
          eventPropGetter={(event) => ({
            style: {
              backgroundColor: event.backgroundColor, // Uses residence color
              color: "#fff",
              borderRadius: "5px",
              padding: "4px",
              fontWeight: "bold",
            },
          })}
          views={["month", "week", "day"]}
          startAccessor="start"
          endAccessor="end"
          style={{
            height: "700px",
            fontFamily: "Arial, sans-serif",
            border: "1px solid #ddd",
            borderRadius: "10px",
            padding: "10px",

          }}
          popup={true}
        />
        </div>
      </section>
      <Footer />
    </>
  );
}

export default Availability;
